'use client'

/**
 * Fake vignette — radial gradient overlay that darkens edges/corners.
 * Non-interactive; sits above the canvas but below other HUD elements.
 */
export function Vignette({
  intensity = 0.6,  // 0-1, how dark the corners get
  falloff = 1.2,    // higher = tighter vignette (darkness concentrated at corners)
  color = '0, 0, 0',
}) {
  return (
    <div
      className="fixed inset-0 z-30 pointer-events-none"
      aria-hidden="true"
      style={{
        background: `radial-gradient(ellipse at center, rgba(${color}, 0) 40%, rgba(${color}, ${intensity}) 100%)`,
        mixBlendMode: 'multiply',
      }}
    />
  )
}

export default Vignette
